<script setup>
import { ref } from "vue";

const props = defineProps({
  size: {
    default: 16,
  },
});
const size = ref(props.size * 3);
</script>

<template>
  <Icon icon="svg-spinners:bars-fade" :width="size" :height="size" />
</template>
